import { isPublicEndpoint } from "./seo";

/** Google Analytics 4 measurement ID */
export const GA_MEASUREMENT_ID = "G-NRPKNS0BJB";

/** Classify routes for GA4 reporting (public marketing, auth flow, logged-in app). */
export function getRouteType(pathname) {
  if (isPublicEndpoint(pathname)) return "public";
  if (pathname.startsWith("/auth")) return "auth";
  return "private";
}

/**
 * Track a page view for any route — public, auth, or private (/app, /customer-home, etc.).
 */
export function trackPageView(pathname, search = "") {
  if (typeof window.gtag !== "function") return;

  const pagePath = `${pathname}${search}`;
  const routeType = getRouteType(pathname);

  window.gtag("event", "page_view", {
    page_path: pagePath,
    page_title: document.title,
    page_location: window.location.href,
    route_type: routeType,
  });
}
